// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 알림이력 화면 - 공통 스타일은 PageLayout.css 참조 */

.mh-panel {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.mh-title-link {
  color: #1A73E8;
  text-decoration: underline;
  cursor: pointer;
}

.mh-sent-ok {
  color: #1a8a4a;
  font-weight: 600;
}

.mh-sent-fail {
  color: #999;
}

.mh-paging {
  display: flex;
  gap: 4px;
  justify-content: center;
  padding: 10px 0;
}

.mh-page-btn {
  border: 1px solid #ddd;
  background: white;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
}

.mh-page-btn.active {
  background: #4a90e2;
  border-color: #4a90e2;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/pages/marketplace/MarketplaceAlertHistoryPage.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd","sourcesContent":["/* 알림이력 화면 - 공통 스타일은 PageLayout.css 참조 */\n\n.mh-panel {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.mh-title-link {\n  color: #1A73E8;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.mh-sent-ok {\n  color: #1a8a4a;\n  font-weight: 600;\n}\n\n.mh-sent-fail {\n  color: #999;\n}\n\n.mh-paging {\n  display: flex;\n  gap: 4px;\n  justify-content: center;\n  padding: 10px 0;\n}\n\n.mh-page-btn {\n  border: 1px solid #ddd;\n  background: white;\n  border-radius: 4px;\n  padding: 4px 10px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.mh-page-btn.active {\n  background: #4a90e2;\n  border-color: #4a90e2;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
